import { t } from "../../i18n"

export default function ChangeCompanyButton({
  onClick,
  disabled = false,
}: {
  onClick: () => void
  disabled?: boolean
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="rounded-full border-2 border-primary bg-white px-4 py-1.5 font-source font-semibold text-primary disabled:opacity-60"
    >
      {t("companies.changeCompany")}
    </button>
  )
}
